import React, { useEffect, useRef, useState } from 'react';
import { close, open } from '../../helpers';

import PropTypes from 'prop-types';

const CaseStudyFilter = props => {
  const [expanded, setExpanded] = useState(props.expanded);
  const options = useRef();
  const el = useRef();

  const toggle = () => {
    if (expanded) {
      close(options.current);
    } else {
      open(options.current);
    }

    setExpanded(!expanded);
  };


  const totalCount = Object.values(props.count).reduce((a, b) => a + b, 0);

  return (
    <div className="checkbox-filter" ref={el}>
      <button
        onClick={toggle}
        className={`checkbox-filter__toggle ${
          totalCount < 1 ? 'checkbox-filter__toggle--disabled' : ''
        }`}
        aria-haspopup="true"
        aria-expanded={expanded ? 'true' : 'false'}
      >
        <span>{props.label}</span>
        <span className="checkbox-filter__toggle-icon"></span>
      </button>
      <div
        ref={options}
        className="checkbox-filter__options"
        aria-hidden={expanded ? 'false' : 'true'}
      >
        <ul className="checkbox-filter__list">
          {props.options.length > 0
            ? [...props.options]
                .sort((a, b) => a.localeCompare(b))
                .map((opt, i) => (
                  <li key={opt}>
                    <label
                      className={`checkbox-filter__option ${
                        !props.count[opt] ? 'disabled' : ''
                      }`}
                    >
                      <input
                        disabled={!props.count[opt]}
                        onChange={props.onChange}
                        type="checkbox"
                        name={props.name}
                        value={opt}
                        checked={props.selected.includes(opt)}
                      />
                      <span className="checkbox-filter__option-checkmark"></span>
                      <span className="checkbox-filter__label-count-wrapper">
                        <span>{opt}</span>
                        <span>{props.count[opt]}</span>
                      </span>
                    </label>
                  </li>
                ))
            : null}
        </ul>
      </div>
    </div>
  );
};

CaseStudyFilter.defaultProps = {
  defaultValue: []
};

CaseStudyFilter.propTypes = {
  defaultValue: PropTypes.array
};

export default CaseStudyFilter;
